import React from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { X } from "lucide-react";
import { CELIA_MEETING_EMBED_URL } from "@/components/thales/celiaMeeting";

interface CeliaMeetingModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const CeliaMeetingModal: React.FC<CeliaMeetingModalProps> = ({ isOpen, onClose }) => {
  return (
    <Dialog open={isOpen} onOpenChange={(o) => !o && onClose()}>
      <DialogContent
        className="max-w-4xl w-[95vw] h-[85vh] p-0 overflow-hidden"
        style={{ zIndex: 100000 }}
      >
        <button
          onClick={onClose}
          className="absolute right-3 top-3 z-10 rounded-full bg-white/90 hover:bg-white p-1.5 shadow"
          aria-label="Fermer"
        >
          <X className="h-4 w-4" />
        </button>
        <iframe
          src={CELIA_MEETING_EMBED_URL}
          title="Réserver un créneau avec Célia"
          className="w-full h-full border-0"
        />
      </DialogContent>
    </Dialog>
  );
};

export default CeliaMeetingModal;
